var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderDelivery.length > 0
    ? _c(
        "div",
        _vm._l(_vm.orderDelivery, function(delivery) {
          return _c("div", { key: delivery.deliveryType }, [
            delivery.deliveryType == "SHSM"
              ? _c("div", { staticClass: "flex flex-item1 mar20-b border" }, [
                  _c("div", { staticClass: "min-w373" }, [
                    _c("div", { staticClass: "flex pad25" }, [
                      _c("div", { staticClass: "wh100 radius4 overflow" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.goodsPic + "?imageView2/1/w/100/h/100"
                          }
                        })
                      ]),
                      _c("div", { staticClass: "mar15-l lh28" }, [
                        _vm._m(0, true),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "no-warp gray6" }, [
                            _vm._v("车主姓名")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      delivery.logisticsCompanyName.substring(
                                        0,
                                        1
                                      ) +
                                        new Array(
                                          delivery.logisticsCompanyName.length
                                        ).join("*")
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.logisticsCompanyName))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "no-warp gray6" }, [
                            _vm._v("车主电话")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.logisticInfo.replace(
                                      /^(.{3})(?:\d+)(.{4})$/,
                                      "$1****$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.logisticInfo))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "no-warp gray6",
                              staticStyle: { width: "58px" }
                            },
                            [_vm._v("车牌号")]
                          ),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.licensePlate.replace(
                                      /^(.{1}).+(.)/,
                                      "$1**$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.licensePlate))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "no-warp gray6",
                              staticStyle: { width: "58px" }
                            },
                            [_vm._v("发货时间")]
                          ),
                          _c("div", { staticClass: "mar10-l" }, [
                            _vm._v(_vm._s(delivery.sendTime))
                          ])
                        ]),
                        delivery.goodsQuantity && delivery.goodsQuantity > 1
                          ? _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "no-warp gray6",
                                  staticStyle: { width: "58px" }
                                },
                                [_vm._v("发货数量")]
                              ),
                              _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.goodsQuantity))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._m(1, true)
                ])
              : _vm._e(),
            delivery.deliveryType == "LOGISTICS"
              ? _c("div", { staticClass: "flex flex-item1 mar20-b border" }, [
                  _c("div", { staticClass: "flex flex-column min-w373" }, [
                    _c("div", { staticClass: "flex pad25" }, [
                      _c("div", { staticClass: "wh100 radius4 overflow" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.goodsPic + "?imageView2/1/w/100/h/100"
                          }
                        })
                      ]),
                      _c("div", { staticClass: "mar15-l lh28" }, [
                        _vm._m(2, true),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "no-warp gray6" }, [
                            _vm._v("物流名称")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.logisticsCompanyName.replace(
                                      /^(.{1}).+(.)/,
                                      "$1**$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.logisticsCompanyName))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "no-warp gray6" }, [
                            _vm._v("物流单号")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.logisticsNum.replace(
                                      /^(.{1}).+(.)/,
                                      "$1**$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.logisticsNum))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "no-warp gray6",
                              staticStyle: { width: "58px" }
                            },
                            [_vm._v("发货时间")]
                          ),
                          _c("div", { staticClass: "mar10-l" }, [
                            _vm._v(_vm._s(delivery.sendTime))
                          ])
                        ]),
                        delivery && delivery.goodsQuantity > 1
                          ? _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "no-warp gray6",
                                  staticStyle: { width: "58px" }
                                },
                                [_vm._v("发货数量")]
                              ),
                              _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.goodsQuantity))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "border-l flex-auto pad30" }, [
                    _vm._m(3, true),
                    delivery.expressVO &&
                    delivery.expressVO.data &&
                    delivery.expressVO.data.length > 0 &&
                    !_vm.dataMasking
                      ? _c(
                          "div",
                          { staticClass: "pad30-l relative flex-auto mar2-l" },
                          [
                            _c("div", {
                              staticClass: "line",
                              staticStyle: {
                                width: "1px",
                                bottom: "3px",
                                left: "213px"
                              }
                            }),
                            _vm._l(delivery.expressVO.data, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "flex mar10-b" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "f12 mar10-r",
                                      staticStyle: { "min-width": "110px" }
                                    },
                                    [_vm._v(_vm._s(item.timeM))]
                                  ),
                                  _c("div", { staticClass: "certificate" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center mar5-r"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "f12 mar10-r" },
                                          [_vm._v(_vm._s(item.timeH))]
                                        ),
                                        _c("div", {
                                          staticClass:
                                            "radius20 z-index2 flex-shrink self-start ball"
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "mar10-l fb f12" },
                                          [_vm._v(_vm._s(item.context))]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _c("div", [
                          _vm._m(4, true),
                          _c("div", { staticClass: "text-center mar10-t" }, [
                            _vm._v("暂无物流相关信息，如有疑问，请联系平台客服")
                          ])
                        ])
                  ])
                ])
              : _vm._e(),
            delivery.deliveryType == "EXPRESS"
              ? _c("div", { staticClass: "flex flex-item1 mar20-b border" }, [
                  _c("div", { staticClass: "min-w373" }, [
                    _c("div", { staticClass: "flex pad25" }, [
                      _c("div", { staticClass: "wh100 radius4 overflow" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.goodsPic + "?imageView2/1/w/100/h/100"
                          }
                        })
                      ]),
                      _c("div", { staticClass: "mar15-l lh28" }, [
                        _vm._m(5, true),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "gray6 no-warp" }, [
                            _vm._v("快递名称")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.logisticsCompanyName.replace(
                                      /^(.{1}).+(.)/,
                                      "$1**$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.logisticsCompanyName))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "gray6 no-warp" }, [
                            _vm._v("快递单号")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.logisticsNum.replace(
                                      /^(.{1}).+(.)/,
                                      "$1**$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.logisticsNum))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "no-warp gray6",
                              staticStyle: { width: "58px" }
                            },
                            [_vm._v("发货时间")]
                          ),
                          _c("div", { staticClass: "mar10-l" }, [
                            _vm._v(_vm._s(delivery.sendTime))
                          ])
                        ]),
                        delivery && delivery.goodsQuantity > 1
                          ? _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "no-warp gray6",
                                  staticStyle: { width: "58px" }
                                },
                                [_vm._v("发货数量")]
                              ),
                              _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.goodsQuantity))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "border-l flex-auto pad30" }, [
                    _vm._m(6, true),
                    delivery.expressVO &&
                    delivery.expressVO.data &&
                    delivery.expressVO.data.length > 0 &&
                    !_vm.dataMasking
                      ? _c(
                          "div",
                          { staticClass: "pad30-l relative flex-auto mar2-l" },
                          [
                            _c("div", {
                              staticClass: "line",
                              staticStyle: {
                                width: "1px",
                                bottom: "3px",
                                left: "213px"
                              }
                            }),
                            _vm._l(delivery.expressVO.data, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "flex mar10-b" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "f12 mar10-r",
                                      staticStyle: { "min-width": "110px" }
                                    },
                                    [_vm._v(_vm._s(item.timeM))]
                                  ),
                                  _c("div", { staticClass: "certificate" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center mar5-r"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "f12 mar10-r" },
                                          [_vm._v(_vm._s(item.timeH))]
                                        ),
                                        _c("div", {
                                          staticClass:
                                            "radius20 z-index2 flex-shrink self-start ball"
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "mar10-l fb f12" },
                                          [_vm._v(_vm._s(item.context))]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _c("div", [
                          _vm._m(7, true),
                          _c("div", { staticClass: "text-center mar10-t" }, [
                            _vm._v("暂无物流相关信息，如有疑问，请联系平台客服")
                          ])
                        ])
                  ])
                ])
              : _vm._e(),
            delivery.deliveryType == "DELIVERYGOODSHL"
              ? _c("div", { staticClass: "flex flex-item1 mar20-b border" }, [
                  _c("div", { staticClass: "flex flex-column min-w373" }, [
                    _c("div", { staticClass: "flex pad25" }, [
                      _c("div", { staticClass: "wh100 radius4 overflow" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.goodsPic + "?imageView2/1/w/100/h/100"
                          }
                        })
                      ]),
                      _c("div", { staticClass: "mar15-l lh28" }, [
                        _vm._m(8, true),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "gray6 no-warp" }, [
                            _vm._v("车主姓名")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.driverName.substring(0, 1) +
                                      new Array(
                                        delivery.driverName.length
                                      ).join("*")
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.driverName))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "gray6 no-warp" }, [
                            _vm._v("车主电话")
                          ]),
                          _vm.dataMasking
                            ? _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(
                                  _vm._s(
                                    delivery.cellPhoneNum.replace(
                                      /^(.{3})(?:\d+)(.{4})$/,
                                      "$1****$2"
                                    )
                                  )
                                )
                              ])
                            : _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.cellPhoneNum))
                              ])
                        ]),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "no-warp gray6",
                              staticStyle: { width: "58px" }
                            },
                            [_vm._v("发货时间")]
                          ),
                          _c("div", { staticClass: "mar10-l" }, [
                            _vm._v(_vm._s(delivery.sendTime))
                          ])
                        ]),
                        delivery && delivery.goodsQuantity > 1
                          ? _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "no-warp gray6",
                                  staticStyle: { width: "58px" }
                                },
                                [_vm._v("发货数量")]
                              ),
                              _c("div", { staticClass: "mar10-l" }, [
                                _vm._v(_vm._s(delivery.goodsQuantity))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "border-l flex-auto pad30" }, [
                    _vm._m(9, true),
                    _c("div", { staticClass: "pad30-l flex-auto mar2-l" }, [
                      _c("div", { staticClass: "mar5-b" }, [
                        _vm._v(
                          "· 物流 当前状态请联系司机 " +
                            _vm._s(delivery.driverName) +
                            " " +
                            _vm._s(delivery.cellPhoneNum)
                        )
                      ]),
                      _c("div", { staticClass: "pad25" }),
                      _vm._m(10, true)
                    ])
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "border-l flex-shrink pad30-t pad20-lr w290"
                    },
                    [
                      _c("div", { staticClass: "f16 fb mar10-b" }, [
                        _vm._v("运输凭证")
                      ]),
                      delivery.expressVO &&
                      delivery.expressVO.fileList &&
                      delivery.expressVO.fileList.length > 0 &&
                      !_vm.dataMasking
                        ? _c("div", { staticClass: "relative certificate" }, [
                            _c("div", {
                              staticClass: "line",
                              staticStyle: { bottom: "84px" }
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex mar10-t mar20-b mar19-l flex-wrap"
                              },
                              _vm._l(delivery.expressVO.fileList, function(
                                fileUrl,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "wh64 radius4 mar5-r overflow"
                                  },
                                  [
                                    fileUrl.imgType && fileUrl.imgType == 1
                                      ? _c("video", {
                                          staticClass: "video-player",
                                          attrs: {
                                            src:
                                              fileUrl.imgUrl +
                                              "?imageView2/1/w/80/h/80"
                                          }
                                        })
                                      : _vm._e(),
                                    _c("el-image", {
                                      attrs: {
                                        src:
                                          fileUrl.imgUrl +
                                          "?imageView2/1/w/80/h/80",
                                        "preview-src-list": delivery.expressVO.fileList.map(
                                          function(item) {
                                            return item.imgUrl
                                          }
                                        )
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              : _vm._e()
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "no-warp gray6" }, [_vm._v("发货方式")]),
      _c("div", { staticClass: "mar10-l" }, [_vm._v("送货上门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "border-l flex-auto pad30" }, [
      _c("div", { staticClass: "flex mar20-b items-center" }, [
        _c("img", {
          attrs: { src: require("../../order/detail/images/cart.png") }
        }),
        _c("div", { staticClass: "mar10-l fb f16" }, [_vm._v("物流跟踪")])
      ]),
      _c("div", { staticClass: "text-center relative mar-t-20" }, [
        _c("img", {
          attrs: { src: require("../../order/detail/images/cart-trans.png") }
        })
      ]),
      _c("div", { staticClass: "text-center mar10-t" }, [
        _vm._v("暂无物流相关信息，如有疑问，请联系平台客服")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "no-warp gray6" }, [_vm._v("发货方式")]),
      _c("div", { staticClass: "mar10-l" }, [_vm._v("物流发货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mar20-b items-center" }, [
      _c("img", {
        attrs: { src: require("../../order/detail/images/cart.png") }
      }),
      _c("div", { staticClass: "mar10-l fb f16" }, [_vm._v("物流跟踪")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center relative mar-t-20" }, [
      _c("img", {
        attrs: { src: require("../../order/detail/images/cart-trans.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "gray6 no-warp" }, [_vm._v("发货方式")]),
      _c("div", { staticClass: "mar10-l" }, [_vm._v("快递发货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mar20-b items-center" }, [
      _c("img", {
        attrs: { src: require("../../order/detail/images/cart.png") }
      }),
      _c("div", { staticClass: "mar10-l fb f16" }, [_vm._v("物流跟踪")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center relative mar-t-20" }, [
      _c("img", {
        attrs: { src: require("../../order/detail/images/cart-trans.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "gray6 no-warp" }, [_vm._v("发货方式")]),
      _c("div", { staticClass: "mar10-l" }, [_vm._v("货联发货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex mar20-b items-center" }, [
      _c("img", {
        attrs: { src: require("../../order/detail/images/cart.png") }
      }),
      _c("div", { staticClass: "mar10-l fb f16" }, [_vm._v("物流跟踪")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex justify-center btn-group text-center" },
      [
        _c(
          "div",
          {
            staticClass: "item pointer",
            staticStyle: { "max-width": "302px" }
          },
          [_vm._v("查看轨迹")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }